import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { EntitlementDeniedState, LoadingState } from "@odingard/design-system";
import { useAuth } from "../lib/auth";
import { useAsync } from "../lib/useAsync";
import { api } from "../lib/api";

// Fail-closed route guard for Policy AI. Requires an active organization and
// the policy_ai.enabled entitlement. The Worker re-checks both server-side;
// this only keeps unentitled users out of the UI.
export function PolicyGuard({
  children,
  entitlement = "policy_ai.enabled",
}: {
  children: ReactNode;
  entitlement?: string;
}) {
  const { activeOrg } = useAuth();
  const navigate = useNavigate();
  const orgId = activeOrg?.id ?? "";
  const state = useAsync(async () => (await api.entitlements(orgId)).entitlements, [orgId]);

  if (state.loading) return <LoadingState label="Checking your access…" />;
  const entitled =
    state.data?.some((e) => e.key === entitlement && ["ALLOWED", "TRIAL"].includes(e.status)) ?? false;
  if (!entitled) {
    return <EntitlementDeniedState product="Policy AI" onUpgrade={() => navigate("/pricing")} />;
  }
  return <>{children}</>;
}
